<ng-container
  provideElements
  [documentId]="documentId"
  [reportIndex]="reportIndex"
  [funds]="selectedFund.get()">

  <wct-grid-layout [columns]="1">
    <wct-element-host [element]="'ISIN' | element | async" [options]="{ overrideCellCssClasses: 'sd-meta--light' }" class="font-medium"/>
    <wct-element-host [element]="'Anteilsscheinname' | element | async" [options]="{ overrideCellCssClasses: 'sd-headline' }"/>
    <wct-element-host [element]="'Kurzbeschreibung' | element | async" [options]="{ overrideCellCssClasses: 'sd-meta--light' }" class="font-large"/>
    <wct-element-host [element]="'Stand der Daten' | element | async" [options]="{ overrideCellCssClasses: 'sd-meta--light' }" class="font-small"/>
  </wct-grid-layout>

</ng-container>
